import React, { Fragment, useEffect, useState } from 'react';
import FormSection from 'components/sales/formSection/formSectionNew';
import localization from 'assets/localization/localization';
import Regex from 'services/utils/regex/Regex';
import ConstantInput from 'components/sales/Input/constantInput/constantInput';
import { FormGroup } from 'react-bootstrap';
import TimePicker from 'react-times';
import 'react-times/css/classic/default.css';
import DropDownInput from 'components/sales/Input/dropDownInput/dropDownInput';
import { DatePickerInput } from 'rc-datepicker';
import DatePicker from 'components/sales/datePicker/datePicker';
import FileUpload from 'components/sales/fileUpload/fileUpload';
// import './carnival.css';
import { toast, ToastContainer } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import ReactTooltip from "react-tooltip";

const CarnivalForm = ({
  handleValue,
  prefilledData
}) => {
    const inputs = {
        services: '',
        bank_details: '',
        bank_name: '',
        branch_name: '',
        act_number: '',
        ifsc_code: '',
        start_date: '',
        start_time: `${new Date().getHours()}:${new Date().getMinutes()}`,
        end_date: '',
        end_time: `${new Date().getHours()}:${new Date().getMinutes()}`,
        subject: '',
        // members: '',
        // id: '',
        // rwa_members: '',
        // rwaImage: '',
        // services_data: ''
    };
    // const [inputList, setInputList] = useState([{ name:"",image_url: "", position: ""}]);
    const [formData, setData] = useState(inputs);
    const [infraId, setInfraId] = useState(0);
    const [projectName, setProjectName] = useState();
    const [infraIdToCheck, setInfraIdToCheck] = useState();
    const [services, setServices] = useState();
    const [rwaMember, setRwaMember] = useState();
    const [minDateIndex, setMinDateIndex] = useState(null);
    const [addMembers, setAddMembers] = useState(0);
    
    const handleStartDate = (date, dateString) => {
        setData({ ...formData, start_date: dateString });
        setMinDateIndex(dateString);
    };

    const handleEndDate = (date, dateString) => {
        setData({ ...formData, end_date: dateString });
    };

    useEffect(() => {
        if (!formData.partners || formData.partners.length === 0) {
        setData({
            ...formData,
            partners: [{ companyName: '', cost: '' }],
        });
        }
    }, [formData, setData]);

    useEffect(() => {
        if (prefilledData?.carnival !== null && prefilledData?.carnival !== undefined) {
            const {
                id,
                infra_id,
                name,
                start_date,
                start_time,
                end_date,
                end_time,
                services,
                bank_details,
                ifsc_code,
                branch_name,
                act_number,
                bank_name,
                partner_details,
                project_name,
                parent_id,
                site_id
            } = prefilledData?.carnival;
            setTimeout(() => {
                setInfraIdToCheck(infra_id);
                setInfraId(infra_id);
                setProjectName(project_name);
                setData({ ...formData,
                    subject: name,
                    services: services,
                    carnival_id: id,
                    bank_details,
                    site_id,
                    // partners: partner_details,
                    start_date: (parent_id != null) ? start_date : null,
                    end_date: (parent_id != null) ? end_date : null,
                    start_time: (parent_id != null) ? start_time : `${new Date().getHours()}:${new Date().getMinutes()}`,
                    end_time: (parent_id != null) ? end_time : `${new Date().getHours()}:${new Date().getMinutes()}`,
                    // is_update: (parent_id != null) ? true : null
                });
            }, 500);
            
        }
    }, [prefilledData])

  const handleMeetingData = () => {
    if (
        formData.start_date !== '' &&
        formData.end_date !== '' &&
        formData.start_time !== '' &&
        formData.end_time !== '' &&
        formData.carnival_id !== ''
    ) {
        handleValue(formData);
    } else handleValue(null);
  };
  useEffect(() => {
    handleMeetingData();
  }, [formData]);
  
    function onStartChange(value) {
        const { hour, minute } = value;
        setData({ ...formData, start_time: `${hour}:${minute}` });
    }
    function onEndChange(value) {
        const { hour, minute } = value;
        setData({ ...formData, end_time: `${hour}:${minute}` });
    }

    const handlePriceChange = (val, index) => {
      const list2 = formData.services;
      list2[index]["price"] = val;
      setData({
        ...formData,
        services: list2,
      })
    };


    const handlePartnerChange = (index, field, value) => {
        const updatedPartners = [...formData.partners];
        updatedPartners[index][field] = value;
        setData({ ...formData, partners: updatedPartners });
      };
    
      const addPartner = () => {
        setData({
          ...formData,
          partners: [...formData.partners, { companyName: '', cost: '' }],
        });
      };
    
      const removePartner = (index) => {
        if (formData.partners.length > 1) {
          const updatedPartners = [...formData.partners];
          updatedPartners.splice(index, 1);
          setData({ ...formData, partners: updatedPartners });
        }
      };

    const calculateServices = () => {
        if (formData.services?.length > 0) {
            return (
                formData.services.map((x, i) => {
                    return (
                    <>
                    <div className="row">
                        {/* <div className="col-md-1 col-sm-12"></div> */}
                        <div className="col-md-6  col-sm-12">
                        <ConstantInput
                            label={localization.serviceName}
                            value={x.name}
                            disabled
                        />
                        </div>
                        { x.id == 1 || x.id == 2 ?
                            <>
                            {/*(handlePriceChange('', i);)*/}
                            <div className="col-md-6  col-sm-12">
                            <ConstantInput
                                type="text"
                                errorMsg={localization.requiredPrice}
                                label={localization.price}
                                required
                                isStarRequired={true}
                                handleChange={e => handlePriceChange(e, i)}
                                // value = {x?.price}
                                // disabled
                            />
                            </div>
                            </>
                            : null
                        }
                    </div>
                    </>
                );
            })
            );
        }
    };

    
  return (
    <FormSection title={localization.carnivalDetails}>
        <div className="row">
            <div className="col-md-6 col-sm-12">
                <ConstantInput
                    label={localization.projectId}
                    value={infraId}
                    disabled
                />
            </div>
        </div>
        
        {infraId !== 0 ? (
        <>
        <div className="row form-group">
            <div className="col-md-6 col-sm-12">
                <ConstantInput
                    label={localization.projectName}
                    value={projectName}
                    disabled
                />
            </div>
            <div className="col-md-6 col-sm-12">
                <ConstantInput
                    value={formData.subject}
                    label={localization.societyName}
                    errorMsg={localization.enterSocietyName}
                    type="text"
                    maxLength={20}
                    required
                    isStarRequired={true}
                    fullWidth
                    disabled
                />
            </div>
            <div className="col-md-6 col-sm-12">
                <FormGroup
                    className={`date custom_date_picker active-date`}
                >
                    <DatePickerInput
                    value={formData?.start_date ? new Date(formData?.start_date) : null}
                    onChange={handleStartDate}
                    autoClose
                    closeOnClickOutside
                    showOnInputClick
                    locale="en"
                    className="my-custom-datepicker-component"
                    required
                    displayFormat="DD-MM-YYYY"
                    returnFormat="YYYY-MM-DD"
                    minDate={new Date()}
                    />
                    <label>
                    {localization.startDate}{' '}
                    <span className="label-star" style={{ color: 'red' }}>
                        {' '}
                        *{' '}
                    </span>
                    </label>
                
                </FormGroup>
            </div>
            <div className="col-md-6 col-sm-12">
                <FormGroup>
                    <TimePicker
                    theme="classic"
                    timeFormat="HH:MM"
                    timeMode={24}
                    time={formData?.start_time}
                    onTimeChange={onStartChange}
                    />
                    <label>{localization.startTime}{' '}
                    <span className="label-star" style={{ color: 'red' }}>
                        {' '}
                        *{' '}
                    </span></label>
                    <label className="error date_error">{localization.isRequired}</label>
                </FormGroup>
            </div>
            <div className="col-md-6 col-sm-12">
                <FormGroup
                    className={`date custom_date_picker active-date`}
                >
                    <DatePickerInput
                    value={formData?.end_date ? new Date(formData?.end_date) : null}
                    onChange={handleEndDate}
                    autoClose
                    closeOnClickOutside
                    showOnInputClick
                    locale="en"
                    className="my-custom-datepicker-component"
                    required
                    displayFormat="DD-MM-YYYY"
                    returnFormat="YYYY-MM-DD"
                    minDate={minDateIndex === null 
                        ? new Date()
                        : minDateIndex}
                    />
                    <label>
                    {localization.endDate}{' '}
                    <span className="label-star" style={{ color: 'red' }}>
                        {' '}
                        *{' '}
                    </span>
                    </label>
                
                </FormGroup>
            </div>
            <div className="col-md-6 col-sm-12">
                <FormGroup>
                    <TimePicker
                    theme="classic"
                    timeFormat="HH:MM"
                    timeMode={24}
                    time={formData?.end_time}
                    onTimeChange={onEndChange}
                    />
                    <label>{localization.endTime}{' '}
                    <span className="label-star" style={{ color: 'red' }}>
                        {' '}
                        *{' '}
                    </span></label>
                    <label className="error date_error">{localization.isRequired}</label>
                </FormGroup>
            </div>
        </div>

        <div className="row form-group">
            
        </div>

        {/* <FormSection title={localization.serviceDetails}>
            {formData.services?.length > 0 ?
                (calculateServices())
                :null
            }
        </FormSection> */}

                </>
        ) : null}

        <FormSection title="Bank Details">
            <div className="col-md-6 col-sm-12">
                <ConstantInput
                label={'Bank Name'}
                type={'text'}
                value={formData?.bank_details?.bank_name}
                handleChange={(value) => setData({
                    ...formData,
                    bank_name: value,
                    bank_details: {
                        ...formData.bank_details,
                        bank_name: value
                    }
                })} 
                // disabled={formData?.isEdit}
                />
            </div>

            <div className="col-md-6 col-sm-12">
                <ConstantInput
                label={'Account Number'}
                type={'number'}
                value={formData?.bank_details?.act_number}
                handleChange={(value) => setData({
                    ...formData,
                    act_number: value,
                    bank_details: {
                        ...formData.bank_details,
                        act_number: value
                    }
                })} 
                // disabled={formData?.isEdit}
                />
            </div>

            <div className="col-md-6 col-sm-12">
                <ConstantInput
                label={'IFSC Code'}
                type={'text'}
                value={formData?.bank_details?.ifsc_code}
                handleChange={(value) => setData({
                    ...formData,
                    ifsc_code: value,
                    bank_details: {
                        ...formData.bank_details,
                        ifsc_code: value
                    }
                })} 
                // disabled={formData?.isEdit}
                />
            </div>

            <div className="col-md-6 col-sm-12">
                <ConstantInput
                label={'Branch Name of the bank'}
                type={'text'}
                value={formData?.bank_details?.branch_name}
                handleChange={(value) => setData({
                    ...formData,
                    branch_name: value,
                    bank_details: {
                        ...formData.bank_details,
                        branch_name: value
                    }
                })} 
                // disabled={formData?.isEdit}
                />
            </div>
        </FormSection>

<FormSection title="Partner Details">
        {(formData.partners || []).map((partner, index) => (
            <div key={index} className="row mb-3 border p-2">
            <div className="col-md-6 col-sm-12">
                <ConstantInput
                label="Name of the Company"
                type="text"
                // isStarRequired={true}
                value={partner.companyName}
                handleChange={(value) => handlePartnerChange(index, 'companyName', value)}
                disabled={formData?.isEdit}
                />
            </div>

            <div className="col-md-6 col-sm-12">
                <ConstantInput
                label="Cost of Partner"
                type="number"
                // isStarRequired={true}
                value={partner.cost}
                handleChange={(value) => handlePartnerChange(index, 'cost', value)}
                disabled={formData?.isEdit}
                />
            </div>

            {formData.partners.length > 1 && (
                <div className="col-md-12 mt-2">
                <button
                    type="button"
                    className="btn btn-danger btn-sm me-2"
                    onClick={() => removePartner(index)}
                    disabled={formData?.isEdit}
                >
                    Remove
                </button>
                </div>
            )}
            </div>
        ))}

        <div className="col-md-12">
            <button
            type="button"
            className="btn btn-sm btn-primary me-2"
            onClick={addPartner}
            disabled={formData?.isEdit}
            >
            Add Partner
            </button>
        </div>
        </FormSection>

    </FormSection>
  );
};

CarnivalForm.propTypes = {};

export default CarnivalForm;
